import { getAccessToken } from "@lib/shared/cookies";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig, AxiosError } from "axios";
import { ServerRequest } from "@lib/shared/types";
import { Menu } from "./domainInfo";

export interface GetMenusResponse {
    success: boolean;
    data: Menu[];
}

export const getMenus = async (
    req?: ServerRequest,
): Promise<{ data: Menu[] | null; error: AxiosError | null }> => {
    const isServer = !!req;
    const accessToken = isServer
        ? (req.accessToken as string)
        : (getAccessToken() as string);

    const config: AxiosRequestConfig = isServer
        ? {
              method: "get",
              url: `/api/web/v1/menus`,
              headers: {
                  Authorization: `Bearer ${accessToken}`,
                  "X-DOMAIN-NAME": `${req.headers.host ?? ""}`,
                  "X-Language": `${req.locale ?? "en"}`,
              },
          }
        : {
              method: "post",
              url: `/api/menus`,
              headers: {
                  Authorization: `Bearer ${accessToken ?? ""}`,
              },
          };

    const { data: menusResponse, error } = await apiHandler<GetMenusResponse>(
        () => (isServer ? HTTP.server(config) : HTTP.client(config)),
    );

    return {
        data: menusResponse?.data ?? null,
        error,
    };
};
